import { FC, useEffect, useMemo, useRef, useState } from "react";
import ModalInfo from "./ModalInfo";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useReactiveVar } from "@apollo/client/react";
import { globalErrorVar } from "App";
import { AuthService } from "services";
import { SWITCH_ACCOUNT_DENIED_START_SECONDS } from "helpers/utils/switchAccountDenied";

interface SwitchAccountDeniedModalProps {
}

const SwitchAccountDeniedModal: FC<SwitchAccountDeniedModalProps> = () => {
  const [second, setSecond] = useState<number>(SWITCH_ACCOUNT_DENIED_START_SECONDS);
  const graphqlGlobalVar = useReactiveVar(globalErrorVar);
  const open = useMemo(() => graphqlGlobalVar?.isSwitchAccountDeniedResponse ?? false, [graphqlGlobalVar?.isSwitchAccountDeniedResponse]);
  // We use a Ref to store the "Deadline" so it doesn't change on re-renders
  const endTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (!open || second <= 0) {
      endTimeRef.current = null; 
      return;
    }

    if (!endTimeRef.current) {
      endTimeRef.current = Date.now() + second * 1000;
    }

    const interval = setInterval(() => {
      const now = Date.now();
      const timeLeft = Math.max(0, Math.floor((endTimeRef.current! - now) / 1000));

      setSecond(timeLeft);

      if (timeLeft <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [open, second]);

  useEffect(() => {
    if(second === 0) {
      logOut();
    }
  }, [second])

  const logOut = () => {
    const origin = window.location.origin;
    let d = new Date();
    d.setTime(d.getTime() + 30 * 60 * 1000);
    const signinTimeStamp = d.getTime();
    AuthService.signOut().then(() => {
      //signOut only call BE when localStorage still store user info 
      //manually  call signIn for when signOut already finished in another tabs
      AuthService.UserManager.signinRedirect({
        state: { origin },
        extraQueryParams: {
          stateStamp: signinTimeStamp,
        },
      })
    });
  }

  const contentHTML = () => (
    <div>
      <p>
        You'll be logged out in{" "}
        <span style={{ color: "red" }} data-testid="remaining-seconds">
          {second}
        </span>{" "}
        seconds to protect account security.
      </p>
      <p>This may be due to a password change or account unlinking.</p>
    </div>
  );

  return (
    <ModalInfo
      isOpen={open}
      heading="Session Ended for Security Reasons"
      content=""
      contentHTML={contentHTML}
      toggle={() => {}}
      closePopup={false}
      type="reload"
      okText="Log Out Now"
      onOk={logOut}
      icon={<InfoCircleOutlined />}
      colorIcon="color-blue"
      loading={second < 1}
    />
  );
};

export default SwitchAccountDeniedModal;
